module.exports = __webpack_public_path__ + "img/maintenance.dd4ecc32.png";